<template>
  <div id="homepage">


    <div class="clip-floating" id="clip-floating" v-if="item.youtube_code != '' && is_mobile()">
      <div class="iframe-holder">
        <iframe :src="'https://www.youtube.com/embed/' + item.youtube_code + '?enablejsapi=1&amp;autoplay=1'" frameborder="0" allow="encrypted-media" allowfullscreen="" id="youtubeiframeid"></iframe>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: ["widgets", "item"],
  created(){
    
    
  }
}
</script>
